<template>
  <v-menu
    v-model="showMenu"
    :position-x="position.x"
    :position-y="position.y"
    absolute
  >
    <template v-slot:activator="{ on }" />
    <v-list>
      <template v-for="(item, index) in items">
        <v-list-item
          v-if="item.action != 'divider'"
          :key="item.action + '_' + index"
          dense
          :disabled="shouldDisable(item)"
          @click="selected(item)"
        >
          <v-list-item-icon v-if="item.icon != ''">
            <v-icon small>
              {{ item.icon }}
            </v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            {{ item.label }}
          </v-list-item-title>
        </v-list-item>
        <v-divider
          v-else
          :key="item.action + '_' + index"
        />
      </template>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
    position: {
      type: Object,
      required: true,
    },
    show: {
      type: Boolean,
      required: true,
    },
    selectedItem: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showMenu: false,
    };
  },
  watch: {
    show: function (val) {
      this.showMenu = val;
    },
  },
  methods: {
    selected(item) {
      // Close on select
      this.showMenu = false;
      this.$emit("action", item);
    },
    shouldDisable(item) {
      // Disable item if the selected item is a folder
      if (this.selectedItem && this.selectedItem.type !== "dir") {
        return item.action == "paste";
      }
    },
  },
};
</script>

<style></style>
